import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import ContentLayout from '@/layout/Content'
import store from "./store";
import * as firebase from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: { requiresAuth: true },
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          meta: { requiresAuth: true },
          component: () => import('./views/UserProfile.vue')
        },
        {
          path: '/project',
          name: 'project',
          meta: { requiresAuth: true },
          component: () => import('./views/Project.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          meta: { noAuth: true },
          component: () => import('./views/Login.vue')
        },
        {
          path: '/register/:verification_key',
          name: 'register',
          meta: { noAuth: true },
          component: () => import('./views/Register.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'notfound',
      component: ContentLayout,
      children: [
        {
          path: '*',
          name: 'NotFound',
          component: () => import('./views/NotFound.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const noAuth = to.matched.some(record => record.meta.noAuth);
  const isAuthenticated = firebase.auth().currentUser;

  /*  if(noAuth && isAuthenticated) {
      next('/dashboard')
    } else {
      next();
    }*/

  if (requiresAuth && !isAuthenticated) {
    store.commit('removeUser');
    next('/login')
  } else if (requiresAuth) {
    const docRef = firebase.firestore().collection("users").doc(isAuthenticated.uid);

    docRef.get().then(function (doc) {
      if (doc.exists) {
        store.commit('removeUser');

        const user = {
          uid: isAuthenticated.uid,
          is_admin: doc.data().is_admin,
          email: isAuthenticated.email,
          firstname: doc.data().firstname,
          lastname: doc.data().lastname,
          image: doc.data().image
        };
        store.commit('addUser', user);

        next()
      } else {
        // doc.data() will be undefined in this case
        // eslint-disable-next-line no-console
        console.log("No such document!");
      }
    }).catch(function (error) {
      // eslint-disable-next-line no-console
      console.log("Error getting document:", error);
    });
  } else if (noAuth && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
});

export default router
